import * as bowser from 'bowser';

import { BehaviorSubject, Subject } from 'rxjs';
import { has, startsWith } from 'lodash';

import { AddonParamsMiddleware } from '../addon-params-middleware/addon-params-middleware';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Layoutresolver } from './layout-resolver';
import { LoadTimeService } from '../LoadTimeService/load-time-service';
import { ObservablesService } from '../observables/observables';
import { Router } from '@angular/router';
import { ConfigService } from '../config.service';

@Injectable()
export class LayoutService {
	data: StaticContentModel;
	action: string;
	actionInfo: any;
	staticLayout = new BehaviorSubject<StaticContentModel>(null);
	globalAttributes = new BehaviorSubject<any>(null);
	addonParams = new BehaviorSubject<addonParams>(null);
	currGlobalAttributes: object;
	API_URL: string;

	options: {} = {
		headers: { 'Content-Type': 'application/json' },
		withCredentials: startsWith(`${this.configService.getConfig().ENV}`, 'bolt'),
	};
	renderPageFromUISubject = new Subject<StaticContentModel>();
	deviceType: string;

	constructor(
		private httpClient: HttpClient,
		private loadTimeService: LoadTimeService,
		private observablesService: ObservablesService,
		private router: Router,
		private layOutresolver: Layoutresolver,
		private configService: ConfigService
	) {
		this.API_URL = `${this.configService.getConfig().apiBaseUrl}Interview`;
		setTimeout(() => {
			const stage = router.routerState.snapshot.url.replace('/', '');
			const data = {
				DeviceIndicator: this.getDeviceType(),
			};
			this.actionInfo =
				stage != 'InitInterview'
					? { data: data, info: { action: 'GoToStage', stage } }
					: { data: data, info: { action: stage } };
			this.getLayout();
		}, 0);
	}

	async getLayout() {
		const reqId = this.loadTimeService.beginTimeMeasure();
		const res = await this.httpClient.post<Response>(this.API_URL, this.actionInfo, this.options).toPromise();
		this.loadTimeService.addPoint(reqId);
		this.observablesService.ShouldPageLoadEvent = 'none';

		this.setGlobalAttributtesAndAddonParams(res);

		if (res.action == 'redirect') {
			const { url, target = '_self' } = res.instructions;

			setTimeout(() => {
				window.open(url, target);
			}, 500);
			return;
		}

		AddonParamsMiddleware(res.data);
		if (has(res, 'data.metadata') && res.data.metadata.page.state !== 'preloader') {
			const path = has(res, 'data.metadata.page.stage') ? `/${res.data.metadata.page.stage}` : `/`;
		}
		this.data = this.layOutresolver.resolve(res, this.staticLayout);
		this.data.splunkTimerId = reqId;
		this.router.navigate([this.data.data.ui.page.stage]);
		this.staticLayout.next(this.data);
	}

	setGlobalAttributtesAndAddonParams(res: any) {
		this.data = this.layOutresolver.resolve(res, this.staticLayout);
		const d = res.data || null;
		const globalAttr = d && d.globalAttributes ? d.globalAttributes : null;
		const addonParams = d && d.addonParams ? d.addonParams : null;
		if (globalAttr) {
			this.globalAttributes.next(globalAttr);
		} else if (
			this.data &&
			this.data.data &&
			this.data.data.metadata &&
			this.data.data.metadata.page.stage === 'YourRates'
		) {
			// in case global attributes not returned from server we set default values for several result page flags
			this.globalAttributes.next({
				...this.currGlobalAttributes,
				showInfoBlocks: true,
				showComparisonLoader: false,
				showComparison: false,
				covModFlag: this.data.data.globalAttributes && this.data.data.globalAttributes.covModFlag
			});
		}
		if (addonParams) {
			this.addonParams.next(addonParams);
		}
	}

	async get(name: string) {
		try {
			const httpRes = await this.httpClient.get(this.API_URL, this.options).toPromise<any>();
			return httpRes;
		} catch (e) {
			this.router.navigate(['/404']);
		}
	}

	getDeviceType(): string {
		this.deviceType = bowser.getParser(window.navigator.userAgent).getPlatformType();
		const capDeviceType = this.deviceType.charAt(0).toUpperCase() + this.deviceType.slice(1);
		return capDeviceType;
	}
}
